<template>
  <header v-if="$content.options.value.navigation" class="fixed top-0 left-0 w-full z-40">
    <MobileNavigation
      :collapsed="collapsed"
      :links="links"
      :transparent="transparent && !not_found && !privacy && !faq"
    />
    <DesktopNavigation
      :collapsed="collapsed"
      :image="$content.options.value.navigation?.main?.image"
      :links="links"
      :transparent="transparent && !not_found && !privacy && !faq"
    />
  </header>
</template>

<script lang="ts">
import DesktopNavigation from '@/components/navigation/blocks/DesktopNavigation.vue'
import MobileNavigation from '@/components/navigation/blocks/MobileNavigation.vue'

export default {
  name: 'SiteNavigation',
  components: { DesktopNavigation, MobileNavigation },
  data() {
    return {
      collapsed: true,
      collapsedTimeout: null as number | null,
      not_found: false,
      privacy: false,
      faq: false,
      transparent: true,
    }
  },
  computed: {
    links() {
      return this.$content.options.value?.navigation?.main?.links ?? []
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('scrollend', this.handleScrollEnd)
    this.handleTransparency()
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('scrollend', this.handleScrollEnd)
  },
  methods: {
    handleScroll() {
      if (this.collapsedTimeout) {
        clearTimeout(this.collapsedTimeout)
        this.collapsedTimeout = null
      }

      if (window.scrollY === 0) {
        this.collapsed = false
      } else if (!this.collapsed) {
        this.collapsed = true
      }

      this.handleTransparency()
    },
    handleScrollEnd() {
      if (!this.collapsedTimeout) {
        this.collapsedTimeout = setTimeout(() => {
          this.collapsed = false
        }, 150)
      }
    },
    handleTransparency() {
      this.transparent = window.scrollY < 50
    },
  },
  watch: {
    links() {
      if (this.links.length) {
        setTimeout(() => {
          this.collapsed = false
        }, 500)
      }
    },
    '$route.name'() {
      this.privacy = this.$route.name?.toString().includes(this.$routes.PRIVACY_POLICY) ?? false
      this.not_found = this.$route.name?.toString().includes(this.$routes.CATCH_ALL) ?? false
      this.faq = this.$route.name?.toString().includes(this.$routes.FAQ) ?? false
    },
  },
}
</script>
